<template lang="html">
  <div>
    <!-- <div class="font-bold text-md mb-4">Pick a Username & Password</div> -->
    <!-- <div class="">
      <div class="flex justify-between">
        <label class="block text-sm" for="username">Username</label>
        <div class="flex items-center" v-if="suggestedUsernames.length > 0">
          <div @click="setUsername(u)" class="bg-lightgrey hover:bg-darkgrey text-slategrey text-sm font-semibold py-1 ml-2 px-4 rounded-full text-center cursor-pointer" v-for="u in suggestedUsernames">{{ `@${u}` }}</div>
        </div>
      </div>

      <input class="w-full fs-input px-4 py-2 rounded" name="username" type="text" placeholder="Your Username" v-model.trim="username" :class="{ 'is-invalid': $v.username.$error }" @input="validateUsername">
      <div v-if="$v.username.$error" class="invalid-feedback">
        <span v-if="!$v.username.required">Username is required</span>
        <span v-if="!$v.username.isUnique">This username is already registered.</span>
        <span v-if="!$v.username.minLength">Username must be at least 3 characters</span>
        <span v-if="!$v.username.maxLength">Username must be at max 15 characters</span>
        <span v-if="!$v.username.alpha">You must choose characters using a-z in lowercase and 0-9 only. Uppercase letters are not allowed.</span>
      </div>
    </div> -->

    <!-- <div class="">
      <label class="block text-sm text-white" for="password">Password</label>
      <input class="w-full fs-input px-4 py-2 rounded mb-0" name="password" type="password" placeholder="Enter Password" v-model.trim="password" :class="{ 'is-invalid': $v.password.$error }">
      <password v-model="password" :strength-meter-only="true" class="inline" />
      <div v-if="$v.password.$error" class="invalid-feedback">
        <span v-if="!$v.password.required">Password is required</span>
        <span v-if="!$v.password.minLength">Password must be at least 6 characters</span>
        <span v-if="!$v.password.valid && $v.password.minLength">Password must contain a lowercase character, uppercase character, special character and a number.</span>
      </div>
    </div> -->

    <div class="relative">
      <div class="flex absolute inset-y-0 left-0 items-center pl-3 mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill w-6 h-6 text-rspurple" viewBox="0 0 16 16">
          <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>
        </svg>
      </div>
      <input class="w-full fs-input px-4 py-2 rounded mb-0 pl-10" name="password" type="password" placeholder="Enter Password" v-model.trim="password" :class="{ 'is-invalid': $v.password.$error }">
      <password v-model="password" :strength-meter-only="true" class="inline" />
      <div v-if="$v.password.$error" class="invalid-feedback">
        <span v-if="!$v.password.required">Password is required</span>
        <span v-if="!$v.password.minLength">Password must be at least 6 characters<!-- Please pick a more secure password -->.</span>
      </div>
    </div>

    <div class="relative">
      <div class="flex absolute inset-y-0 left-0 items-center pl-3 mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill w-6 h-6 text-rspurple" viewBox="0 0 16 16">
          <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>
        </svg>
      </div>
      <input class="w-full fs-input px-4 py-2 rounded pl-10" name="password_confirmation" type="password" placeholder="Re-enter Password" v-model.trim="password_confirmation" :class="{ 'is-invalid': $v.password_confirmation.$error }">
      <div v-if="$v.password_confirmation.$error" class="invalid-feedback">
        <span v-if="!$v.password_confirmation.required">Re-enter Password is required</span>
        <span v-else-if="!$v.password_confirmation.sameAsPassword">Passwords must match</span>
      </div>
    </div>  

    <!-- <div class="">
      <label class="block text-sm text-white" for="password_confirmation">Re-enter Password</label>
      <input class="w-full fs-input px-4 py-2 rounded" name="password_confirmation" type="password" placeholder="Re-enter Password" v-model.trim="password_confirmation" :class="{ 'is-invalid': $v.password_confirmation.$error }">
      <div v-if="$v.password_confirmation.$error" class="invalid-feedback">
        <span v-if="!$v.password_confirmation.required">Re-enter Password is required</span>
        <span v-else-if="!$v.password_confirmation.sameAsPassword">Passwords must match</span>
      </div>
    </div> -->

    <div class="italic text-xs mt-2 text-white">
      Hint: For secure password, use combination of a lowercase, uppercase, special character and a number
    </div>

    <div class="mt-6">
      <label class="font-bold mb-3 block">
        <input class="mr-2 leading-tight" type="checkbox" v-model="terms_and_conditions" :class="{ 'is-invalid': $v.terms_and_conditions.$invalid }">
        <span class="text-sm">
           I confirm these are my details
        </span>
      </label>
      <div v-if="$v.terms_and_conditions.$invalid && is_clicked" class="invalid-feedback">
        <span v-if="!$v.terms_and_conditions.sameAs">Accept Terms of Service and Privacy Policy</span>
      </div>
    </div>

    <modal class="fs-modal" name="file-preview-modal" width="850px" height="90%" scrollable="true" adaptive="true" :clickToClose="true" @before-close="beforeModalClose">
      <div class="fs-modal-content overflow-scroll p-4 h-full">
        <div class="text-sm">
          Terms of Service
        </div>
        <div class="text-center mt-4">
          <div class="fs-blue-btn inline-block" @click="hideModal()">Close</div>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
  import axios from 'axios';
  import { zxcvbn } from 'zxcvbn';
  import Password from 'vue-password-strength-meter';
  import { required, minLength, maxLength, helpers, sameAs } from 'vuelidate/lib/validators';
  const alpha = helpers.regex('alpha', /^[a-z0-9]*$/);

  export default {
    components: { Password },
    props: {
      currentUser: Object,
      suggestedUsernames: Object,
      stadium_code: String,
    },
    data() {
      return {
        username_id: null,
        username: '',
        status: true,
        password: '',
        password_confirmation: '',
        terms_and_conditions: false,
        is_clicked: false,
      }
    },
    validations: {
      // username: {
      //   required,
      //   alpha,
      //   minLength: minLength(3),
      //   maxLength: maxLength(15),
      //   isUnique(value) {
      //     if (value === '') return true

      //     return this.status;
      //   },
      // },
      password: {
        required,
        minLength: minLength(6),
        // valid: function(value) {
        //   const containsUppercase = /[A-Z]/.test(value)
        //   const containsLowercase = /[a-z]/.test(value)
        //   const containsNumber = /[0-9]/.test(value)
        //   const containsSpecial = /[#?!@$%^&*-]/.test(value)
        //   return containsUppercase && containsLowercase && containsNumber && containsSpecial
        // }
      },
      password_confirmation: { required, sameAsPassword: sameAs('password') },
      terms_and_conditions: { sameAs: sameAs( () => true ) },
      form: ['password', 'password_confirmation', 'terms_and_conditions'],
    },
    created(){
    },
    beforeDestroy() {
    },
    mounted() {
      if(this.currentUser){
        this.username = this.currentUser.data.attributes.username.data.attributes.name;
        // this.username_id = this.currentUser.data.attributes.username.data.id;
        this.status = true;
      }
    },
    methods: {
      validate() {
        this.is_clicked = true
        this.$v.form.$touch();
        var isValid = !this.$v.form.$invalid
        if(this.currentUser){
          this.$emit('on-validate', { username_attributes: { id: this.username_id, name: this.username }, terms_and_conditions: this.terms_and_conditions }, isValid)
        }else{
          this.$emit('on-validate', { password: this.password, password_confirmation: this.password_confirmation, stadium_code: this.stadium_code}, isValid)
        }

        return isValid
      },
      validateUsername(){
        // if(this.currentUser && (this.currentUser.data.attributes.username.data.attributes.name === this.username)){
        //   this.status = true
        // }else{
        //   axios({
        //     method: 'post',
        //     headers: {
        //       "Accept": 'application/vnd.reset+json;version=1',
        //       "X-CSRF-Token": document.getElementsByName('csrf-token')[0].getAttribute('content')
        //     },
        //     url: '/api/username/validate',
        //     data: {
        //       username: this.username
        //     }
        //   }).then((response) => {
        //     this.status = response.data.available;
        //   })
        //   .catch((error) => {
        //     this.status = error.response.data.available;

        //   });
        // }
        return true
      },
      setUsername(username){
        this.username = username;
        this.validateUsername();
      },
      openModal(page){
        this.$modal.show('file-preview-modal');
      },
      hideModal(page){
        this.$modal.hide('file-preview-modal');
      },
    }
  };
</script>

<style scoped>
.invalid-feedback {
  display: block;
  width: 100%;
  font-size: 80%;
  color: #dc3545;
}
</style>